
const user = {
    state: {
        accountId: "",
    },

    mutations: {
        SET_ID: (state, id) => {
            state.accountId = id
        },
        SET_NAME: (state, nickname) => {
            state.nickname = nickname
        },
    },

    actions: {
        // 获取用户信息
        GetUserInfo({ commit }) {
            commit('SET_NAME', '你好')
            commit('SET_ID', 119)
        },
    }
}

export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js